export default __webpack_public_path__ + "static/media/user-plus.c69d17e1.svg";